import { useEffect, useLayoutEffect, useRef, useState } from "react";
import ToolTip from "@/assetsV3/ToolTip";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";
import useSize from "@/hooks/useSize";

type TooltipProps = {
  message: string;
  children: any;
  hideIcon?: boolean;
  changeColor?: boolean;
  position?: "left" | "top" | "right" | "bottom" | undefined;
};

function useIsTouchDevice() {
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    setIsTouch(hasTouch);
  }, []);

  return isTouch;
}

export default function MyTooltip(props: TooltipProps) {
  const isTouch = useIsTouchDevice();

  const [isOpen, setIsOpen] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);

  const toggleTooltip = (event: any) => { event.stopPropagation(); setIsOpen((prev) => !prev) };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [isMobile, setIsMobile] = useState<boolean>(false);
  const windowSize = useSize();
  useLayoutEffect(() => {
    if (windowSize.width < 992) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [windowSize.width]);

  return (
    <TooltipProvider>
      <div ref={tooltipRef}>
        <Tooltip open={isOpen}>
          <TooltipTrigger className="flex gap-2" {...(!isTouch && {
            onMouseEnter: toggleTooltip,
            onMouseLeave: toggleTooltip,
          })}
            {...(isTouch && {
              onClick: toggleTooltip,
            })}>
            {props.children}
          </TooltipTrigger>
          {isOpen && (
            <TooltipContent side={props.position && !isMobile ? props.position : "bottom"} className="flex flex-wrap justify-start items-center gap-3 !bg-outext-sub ml-6 sm:ml-0 !text-outext-main border-none whitespace-normal break-words max-w-[600px] sm:max-w-[400px]">
              {!props.hideIcon ? (
                <ToolTip
                  className={props.changeColor ? "fill-outicon-sub" : ""}
                />
              ) : (
                <></>
              )}

              <span className="text-left w-full font-bold">{props.message}</span>
            </TooltipContent>
          )}
        </Tooltip>
      </div>
    </TooltipProvider>
  );
}
